import styled from 'styled-components';

export const MyPlanHeader = styled.header`
  @media (max-width: 1199px) {
    &&& {
      padding-top: 24px !important;
    }

    .dp-my-plan-header-subtitle {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;
